import React from "react";
import PdfBase from "../../Others/Pdf/PdfBase";
import { generateFaDisposalPdf } from "./generator";
import ExcelBase from "../../Others/Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  assetLines,
  totalAssetLines,
  showNetbookValue,
  twdvSummary,
  bcSummary,
  refSources,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    assetLines,
    totalAssetLines,
    showNetbookValue,
    twdvSummary,
    bcSummary,
    refSources,
    notes,
    reviewNotes,
  ];
  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) => generateFaDisposalPdf(forView, ...sharedArgs)}
        downloadName='Fixed Asset Disposal'
        enableDraftView
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateFaDisposalPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
